import React, { useState, useRef } from "react";


const QuestionBox = ({ onAsk }) => {
  const [question, setQuestion] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [useSuggestions, setUseSuggestions] = useState(false);
  const timeoutRef = useRef(null);

  const fetchQuestions = () => {
const token = localStorage.getItem("authToken");
    const route = useSuggestions ? "samplequestions" : "previousquestions";
    fetch(`https://api.pharmacegroup.co.uk/${route}`, {
      method: "POST",
      headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
      body: JSON.stringify({ groupId: localStorage.getItem("userId") })
    })
      .then(res => res.json())
      .then(data => {
        const safeList = Array.isArray(data.questions) ? data.questions : [];
        const sortedList = useSuggestions
          ? [...safeList].sort((a, b) => a.localeCompare(b))
          : safeList;

        setFilteredQuestions(sortedList);
        setShowDropdown(sortedList.length > 0);
      })
      .catch(err => {
        console.error("Error fetching questions:", err);
        setFilteredQuestions([]);
        setShowDropdown(false);
      });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setQuestion(value);

    if (value.trim().length > 1) {
      fetchQuestions();
    } else {
      setShowDropdown(false);
      setFilteredQuestions([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!question.trim()) return;
    setLoading(true);
    setShowDropdown(false);
    await onAsk(question.trim()); // Preserve question value after
    setLoading(false);
  };

  const handleClear = () => {
    setQuestion("");
    setShowDropdown(false);
    setFilteredQuestions([]);
  };

  const handleBlur = () => {
    timeoutRef.current = setTimeout(() => {
      setShowDropdown(false);
    }, 200);
  };

  const handleFocus = () => {
    if (Array.isArray(filteredQuestions) && filteredQuestions.length > 0) {
      setShowDropdown(true);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <div style={{ position: "relative", width: "1000px" }}>
        <input
          type="text"
          value={question}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder="Ask me a question"
          style={{
            width: "100%",
            padding: "8px 64px 8px 8px",
            fontSize: "16px",
            boxSizing: "border-box"
          }}
        />

        {/* Clear button */}
        {question && (
          <button
            type="button"
            onClick={handleClear}
            style={{
              position: "absolute",
              right: "32px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              fontSize: "18px",
              cursor: "pointer",
              color: "#888"
            }}
            aria-label="Clear"
          >
            ×
          </button>
        )}

        {/* Dropdown arrow button */}
        <button
          type="button"
          onClick={fetchQuestions}
          style={{
            position: "absolute",
            right: "4px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            fontSize: "16px",
            cursor: "pointer",
            color: "#888"
          }}
          aria-label="Show suggestions"
        >
          ▼
        </button>

        {/* Dropdown list */}
        {showDropdown && Array.isArray(filteredQuestions) && filteredQuestions.length > 0 && (
          <ul
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              maxHeight: "200px",
              overflowY: "auto",
              background: "white",
              border: "1px solid #ccc",
              zIndex: 999,
              marginTop: "2px",
              padding: 0,
              listStyle: "none"
            }}
          >
            {filteredQuestions.map((q, idx) => (
              <li
                key={idx}
                onMouseDown={() => {
                  setQuestion(q);
                  setShowDropdown(false);
                }}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee"
                }}
              >
                {q}
              </li>
            ))}
          </ul>
        )}
      </div>

      <button
        type="submit"
        disabled={loading}
        style={{
          padding: "8px 12px",
          fontSize: "0.9rem",
          backgroundColor: loading ? "#add8e6" : "#007bff",
          color: "#fff",
          border: "none",
          cursor: loading ? "default" : "pointer"
        }}
      >
        {loading ? "Searching..." : "Show me the answer"}
      </button>

      <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <input
          type="checkbox"
          checked={useSuggestions}
          onChange={(e) => setUseSuggestions(e.target.checked)}
        />
        Suggestions
      </label>
    </form>
  );
};

export default QuestionBox;
